import React from 'react';
import {Routes, Route} from "react-router-dom";


import Leftbar from './Leftbar';
import MainMenu from "../config/MainMenu"
import Topbar from './Topbar';
import {UseToken} from "../hooks/UseToken";
import DashboardSection from "../sections/dashboard/DashboardSection";

import EnterpriseManager from "../sections/enterprises/EnterpriseManager";
import EmailManager from "../sections/emails/EmailManager";
import LandingManager from "../sections/landings/LandingManager";
import JourneyManager from "../sections/journeys/JourneyManager";
import RoleManager from "../sections/roles/RoleManager";
import UserManager from "../sections/users/UserManager";
import PlanManager from "../sections/plans/PlanManager";
import AudienceManager from "../sections/audiences/AudienceManager";
import SmsManager from "../sections/sms/SmsManager";
import AccountManager from "../sections/accounts/AccountManager";
import Dashboard from "../sections/dashboard/Dashboard";
import LogsManager from "../sections/logs/LogsManager";
import {useAppContext} from "../AppContext";
import {Senders} from "../sections/enterprises/Senders";

const Layout = () => {
    const {hasTopbar} = useAppContext();

    if (UseToken() === null) {
        window.location.href = `${process.env.REACT_APP_BASE_URL}/auth/login`
    }

    return (
        <div className="Layout">
            <Leftbar items={MainMenu}/>
            <div className={`Content${!hasTopbar ? ' full-screen' : ''}`}>
                {hasTopbar && <Topbar/>}

                <div className="Children">
                    <Routes>
                        <Route path="/" element={<Dashboard/>}/>
                        <Route path="/old" element={<DashboardSection/>}/>
                        <Route path="enterprises/*" element={<EnterpriseManager/>}>
                            <Route index element={<EnterpriseManager/>}/>
                            <Route path="new" element={<EnterpriseManager/>}/>
                            <Route path=":id" element={<EnterpriseManager/>}/>
                            <Route path=":id/settings" element={<EnterpriseManager/>}/>
                            <Route path=":id/domains" element={<EnterpriseManager/>}/>
                            <Route path=":id/domains/:id2" element={<EnterpriseManager/>}/>
                            <Route path=":id/domains/:id2/senders" element={<EnterpriseManager/>}/>
                        </Route>

                        <Route path="audiences/*" element={<AudienceManager/>}>
                            <Route index element={<AudienceManager/>}/>
                            <Route path="new" element={<AudienceManager/>}/>
                            <Route path=":id" element={<AudienceManager/>}/>
                            <Route path=":id/fields" element={<AudienceManager/>}/>
                            <Route path=":id/segments" element={<AudienceManager/>}/>
                            <Route path=":id/segments/new" element={<AudienceManager/>}/>
                            <Route path=":id/segments/:id2" element={<AudienceManager/>}/>
                            <Route path=":id/entities" element={<AudienceManager/>}/>
                            <Route path=":id/entities/:id2" element={<AudienceManager/>}/>
                            <Route path=":id/entities/:id2/activity" element={<AudienceManager/>}/>
                            <Route path=":id/entities/:id2/consents" element={<AudienceManager/>}/>
                            <Route path=":id/consent-types" element={<AudienceManager/>}/>
                            <Route path=":id/robinson" element={<AudienceManager/>}/>
                        </Route>

                        <Route path="sms/*" element={<SmsManager/>}>
                            <Route index element={<SmsManager/>}/>
                            <Route path="new" element={<SmsManager/>}/>
                            <Route path=":id" element={<SmsManager/>}/>
                        </Route>


                        <Route path="emails/*" element={<EmailManager/>}>
                            <Route index element={<EmailManager/>}/>
                            <Route path=":id" element={<EmailManager/>}/>
                        </Route>


                        <Route path="landings/*" element={<LandingManager/>}>
                            <Route index element={<LandingManager/>}/>
                            <Route path="new" element={<LandingManager/>}/>
                            <Route path=":id" element={<LandingManager/>}/>
                        </Route>


                        <Route path="roles/*" element={<RoleManager/>}>
                            <Route index element={<RoleManager/>}/>
                            <Route path="new" element={<RoleManager/>}/>
                            <Route path=":id" element={<RoleManager/>}/>
                        </Route>


                        <Route path="users/*" element={<UserManager/>}>
                            <Route index element={<UserManager/>}/>
                            <Route path="new" element={<UserManager/>}/>
                            <Route path=":id" element={<UserManager/>}/>
                        </Route>


                        <Route path="plans/*" element={<PlanManager/>}>
                            <Route index element={<PlanManager/>}/>
                            <Route path="new" element={<PlanManager/>}/>
                            <Route path=":id" element={<PlanManager/>}/>
                        </Route>


                        <Route path="accounts/*" element={<AccountManager/>}>
                            <Route index element={<AccountManager/>}/>
                            <Route path="new" element={<AccountManager/>}/>
                            <Route path=":id" element={<AccountManager/>}/>
                        </Route>


                        <Route path="journeys/*" element={<JourneyManager/>}>
                            <Route index element={<JourneyManager/>}/>
                            <Route path="new" element={<JourneyManager/>}/>
                            <Route path=":id" element={<JourneyManager/>}/>
                            <Route path=":id/limits" element={<JourneyManager/>}/>
                            <Route path=":id/builder" element={<JourneyManager/>}/>
                            <Route path=":id/logs" element={<JourneyManager/>}/>
                            <Route path=":id/statistics" element={<JourneyManager/>}/>
                        </Route>

                        <Route path="logs/*" element={<LogsManager/>}>
                            <Route index element={<LogsManager/>}/>
                            <Route path="new" element={<LogsManager/>}/>
                            <Route path=":id" element={<LogsManager/>}/>
                        </Route>


                    </Routes>
                </div>
            </div>
        </div>
    );
}

export default Layout;